import {
  FETCH_EXTRA_PAYMENT_PAYROLL_REQUEST,
  FETCH_EXTRA_PAYMENT_PAYROLL_SUCCESS,
  FETCH_EXTRA_PAYMENT_PAYROLL_FAILURE,
  SAVE_PAYROLL_REQUEST,
  SAVE_PAYROLL_SUCCESS,
  SAVE_PAYROLL_FAILURE,
  CHANGE_PAYROLL_STATUS_REQUEST,
  CHANGE_PAYROLL_STATUS_SUCCESS,
  CHANGE_PAYROLL_STATUS_FAILURE,
} from './actionTypes';

const initialState = {
  extraPayments: [],
  loading: false,
  error: null,
  success:false
};

const payrollReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_EXTRA_PAYMENT_PAYROLL_REQUEST:
    case SAVE_PAYROLL_REQUEST:
    case CHANGE_PAYROLL_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success:false
      };

    case FETCH_EXTRA_PAYMENT_PAYROLL_SUCCESS:
      return {
        ...state,
        loading: false,
        extraPayments: action.payload,
        success:false
      };

    case SAVE_PAYROLL_SUCCESS:
      return {
        ...state,
        loading: false,
        success:true
      };

    case CHANGE_PAYROLL_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        success:true
      };

    case FETCH_EXTRA_PAYMENT_PAYROLL_FAILURE:
    case SAVE_PAYROLL_FAILURE:
    case CHANGE_PAYROLL_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success:false
      };

    default:
      return state;
  }
};

export default payrollReducer;
